/**
 * @generated SignedSource<<c93161731a842453afbaadc7d271c4a0>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type dailyPulseBlockQuery$data = {
  readonly dailyPulseQuery: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly entityId: string;
        readonly urlAlias: string;
        readonly " $fragmentSpreads": FragmentRefs<"contentBodyContent" | "contentHeadlineContent" | "hooksArticleDateUtilsContent" | "hooksPlusArticleLinkHandlerArticle">;
      };
    }>;
  };
  readonly " $fragmentType": "dailyPulseBlockQuery";
};
export type dailyPulseBlockQuery$key = {
  readonly " $data"?: dailyPulseBlockQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"dailyPulseBlockQuery">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "entityId",
  "storageKey": null
},
v1 = [
  (v0/*: any*/)
],
v2 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "SectionSegmentV2",
    "kind": "LinkedField",
    "name": "sectionsV2",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "value",
        "plural": true,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "Section",
            "abstractKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": (v1/*: any*/),
            "type": "VideoSection",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "urlAlias",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "dailyPulseTypeUuid"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "dailyPulseBlockQuery",
  "selections": [
    {
      "alias": "dailyPulseQuery",
      "args": [
        {
          "fields": [
            {
              "items": [
                {
                  "kind": "Variable",
                  "name": "typeIds.0",
                  "variableName": "dailyPulseTypeUuid"
                }
              ],
              "kind": "ListValue",
              "name": "typeIds"
            }
          ],
          "kind": "ObjectValue",
          "name": "filter"
        },
        {
          "kind": "Literal",
          "name": "first",
          "value": 1
        },
        {
          "kind": "Literal",
          "name": "orderBy",
          "value": {
            "direction": "DESC",
            "field": "PUBLISHED_DATE"
          }
        }
      ],
      "concreteType": "ArticleConnection",
      "kind": "LinkedField",
      "name": "articles",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "ArticleEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Article",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "contentBodyContent"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "contentHeadlineContent"
                },
                {
                  "args": null,
                  "kind": "FragmentSpread",
                  "name": "hooksArticleDateUtilsContent"
                },
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "hooksPlusArticleLinkHandlerArticle",
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "InlineDataFragmentSpread",
                          "name": "helpersCheckCanShowInPlusPlatformContent",
                          "selections": [
                            {
                              "alias": null,
                              "args": null,
                              "kind": "ScalarField",
                              "name": "__typename",
                              "storageKey": null
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "helpersCheckArticleIsInSectionsArticle",
                              "selections": (v2/*: any*/),
                              "args": null,
                              "argumentDefinitions": []
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "helpersCheckIsPlusArticle",
                              "selections": [
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "PaywallType",
                                      "kind": "LinkedField",
                                      "name": "paywallTypes",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "entityUuid",
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "Article",
                                  "abstractKey": null
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "helpersCheckIsStyleArticle",
                              "selections": (v2/*: any*/),
                              "args": null,
                              "argumentDefinitions": []
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "helpersGetArticleTypeArticle",
                              "selections": [
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "ArticleTypeSegment",
                                      "kind": "LinkedField",
                                      "name": "types",
                                      "plural": true,
                                      "selections": [
                                        {
                                          "alias": null,
                                          "args": null,
                                          "concreteType": "ArticleType",
                                          "kind": "LinkedField",
                                          "name": "value",
                                          "plural": true,
                                          "selections": (v1/*: any*/),
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "Article",
                                  "abstractKey": null
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            },
                            {
                              "kind": "InlineDataFragmentSpread",
                              "name": "helpersUseContentSponsorContent",
                              "selections": [
                                {
                                  "alias": null,
                                  "args": null,
                                  "concreteType": "Topic",
                                  "kind": "LinkedField",
                                  "name": "topics",
                                  "plural": true,
                                  "selections": [
                                    (v0/*: any*/),
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Sponsor",
                                      "kind": "LinkedField",
                                      "name": "sponsor",
                                      "plural": false,
                                      "selections": [
                                        {
                                          "args": null,
                                          "kind": "FragmentSpread",
                                          "name": "sponsorTagSponsor"
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "name",
                                          "storageKey": null
                                        },
                                        {
                                          "alias": null,
                                          "args": null,
                                          "kind": "ScalarField",
                                          "name": "type",
                                          "storageKey": null
                                        }
                                      ],
                                      "storageKey": null
                                    }
                                  ],
                                  "storageKey": null
                                },
                                {
                                  "kind": "InlineFragment",
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "kind": "ScalarField",
                                      "name": "sponsorType",
                                      "storageKey": null
                                    }
                                  ],
                                  "type": "Article",
                                  "abstractKey": null
                                },
                                {
                                  "kind": "InlineDataFragmentSpread",
                                  "name": "helpersCheckIsMainTopicContent",
                                  "selections": [
                                    {
                                      "alias": null,
                                      "args": null,
                                      "concreteType": "Topic",
                                      "kind": "LinkedField",
                                      "name": "topics",
                                      "plural": true,
                                      "selections": (v1/*: any*/),
                                      "storageKey": null
                                    }
                                  ],
                                  "args": null,
                                  "argumentDefinitions": []
                                }
                              ],
                              "args": null,
                              "argumentDefinitions": []
                            }
                          ],
                          "args": null,
                          "argumentDefinitions": []
                        },
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "id",
                          "storageKey": null
                        },
                        (v0/*: any*/),
                        (v3/*: any*/)
                      ],
                      "type": "Content",
                      "abstractKey": "__isContent"
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                },
                (v0/*: any*/),
                (v3/*: any*/)
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};
})();

(node as any).hash = "2d75481685e8520a8cbdb46cb291b8f1";

export default node;
